import AxiosService from '../AxiosService';
import { queryString, apiUrl } from '../config/globals';

export const login = (data) => AxiosService.post(`${apiUrl('user')}/login`, data);

export const logout = () => AxiosService.get(`${apiUrl('user', 'private')}/logout`);

export const forgotPassword = (data) => AxiosService.put(`${apiUrl('user')}/forgot-password`, data);

export const forgotPasswordOtpInput = (data) => AxiosService.post(`${apiUrl('user', 'private')}/verify-reset-password-otp`, data);

export const forgotPasswordResendOtp = () => AxiosService.get(`${apiUrl('user', 'private')}/resend-forgot-password`);

export const forgotPasswordSubmit = (data) => AxiosService.post(`${apiUrl('user', 'private')}/reset-password`, data);

export const resetPasswordLinkChecker = (data) => AxiosService.get(`${apiUrl('user')}/check-forgot-password?${queryString(data)}`);

export const changePassword = (data) => AxiosService.post(`${apiUrl('user', 'private')}/change-password`, data);

export const changeUserLogo = (data) => AxiosService.post(`${apiUrl('user', 'private')}/update-profile-logo?${queryString(data)}`);
